import styled from 'styled-components';

var TreeNodeExpandIconWrapper = styled.div.withConfig({
  displayName: "ExpandIconWrapper__TreeNodeExpandIconWrapper",
  componentId: "sc-saclnb-0"
})(["&&{position:absolute;inset-inline-start:-32px;top:calc(50% - 2px);transform:translateY(-50%);}"]);

export { TreeNodeExpandIconWrapper };
